module.exports = __webpack_public_path__ + "img/82.38463cfd.jpg";